import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

function Header() {
    const navigate = useNavigate();
    const handleNavigation = (sectionId) => {
        navigate("/", { replace: true });
        setTimeout(() => {
            if (sectionId) {
                const section = document.getElementById(sectionId);
                section.scrollIntoView({ behavior: 'smooth' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 100);
    };

    return (
        <Navbar expand="lg" className="bg-white shadow-sm py-3" sticky="top">
            <Container>
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                    <span className='ml-2 fs-4 fw-bold' style={{ background: 'linear-gradient(135deg, #6cc3f4 0%, #80abe9 50%, #b26dcd 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>VisionThink Tech</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto me-3">
                        <Nav.Link className='ml-2' as={Link} onClick={() => handleNavigation("features")}>Features</Nav.Link>
                        <Nav.Link className='ml-2' as={Link} onClick={() => handleNavigation("benefits")}>Benefits</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;